import script from "./UiCollapse.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiCollapse.vue?vue&type=script&setup=true&lang=ts"

import "./UiCollapse.vue?vue&type=style&index=0&id=0af04d4a&lang=css"

const __exports__ = script;

export default __exports__